import React, { useEffect, useState } from "react";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import DataTable from "react-data-table-component";
import { Col, Row, Card, Form, InputGroup } from "react-bootstrap";
import {
  GeneratePromoCode,
  GetPromoCodesData,
} from "../../redux/auth-reducer/auth-service";
import { Footer } from "../../Footer";
import { ToastContainer, toast } from "react-toastify";
import { Button } from "react-bootstrap";
import { DatePicker } from "rsuite";
import dayjs from "dayjs";
import * as icons from "react-bootstrap-icons";
import { DATE_TIME_REQUIRED } from "../../utils/helper/validation";

export const Generate_PromoCode = () => {
  const [data, setData] = useState(false);
  const [sidebar, setSidebar] = useState(false);
  const [endDate, setEndDate] = useState(null);
  const [validity, setValidity] = useState("");
  const [dateValid, setDateValid] = useState(true);
  /** Blank while "Unlimited" is ticked; the API is told unlimited by an empty maxRedemptions. */
  const [maxRedemptions, setMaxRedemptions] = useState("1");
  const [isUnlimited, setIsUnlimited] = useState(false);
  const [grantDurationDays, setGrantDurationDays] = useState("30");
  const [searchText, setSearchText] = useState("");
  const [dataListItem, setDataListItem] = useState([]);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const pageOptions = [10, 20, 30, 50];
  const [count, setCount] = useState(0);
  function sidebarfun() {
    setData(!data);
  }
  const handleEndDateChange = (date) => {
    setDateValid(true);
    setEndDate(date);
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleCode = async (event) => {
    event.preventDefault();
    if (!endDate) {
      setDateValid(false);
      return;
    } else {
      setDateValid(true);
    }

    if (!isUnlimited && !(Number(maxRedemptions) >= 1)) {
      toast.error("Max redemptions must be at least 1, or tick Unlimited.");
      return;
    }

    if (!(Number(grantDurationDays) >= 1)) {
      toast.error("Free access must last at least 1 day.");
      return;
    }

    if (endDate < new Date()) {
      toast.error(
        "Your selected time has already expired. Please select a different time."
      );
      return;
    }

    // toISOString(), not toLocaleString(): the API compares this against GETUTCDATE() and the
    // grid below renders it back as UTC, so sending local wall-clock showed the admin an expiry
    // several hours from the one they picked, and made this screen's "already expired" check
    // disagree with the server's near the boundary.
    await GeneratePromoCode(
      endDate.toISOString(),
      isUnlimited ? null : Number(maxRedemptions),
      Number(grantDurationDays)
    ).then((response) => {
      if (response?.data?.status == true) {
        toast.success(response?.data?.message);
        setCount(count + 1);
      } else if (response?.data?.status == false) {
        toast.error(response?.data?.message);
      } else {
        toast.error(response?.data?.error);
      }
    });
  };

  const GetData = async (data) => {
    try {
      const response = await GetPromoCodesData(data); // Call your API function
      if (response?.data) {
        setDataListItem(response.data.data.dataList || []); // Set the item list
        setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // Effect to fetch data when current page changes
  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: false,
    };
    GetData(data); // Fetch data when currentPage changes
  }, [currentPage, count]); // Dependency on currentPage

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: false,
    };
    GetData(data);

    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };
  // Handle page change
  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }
  const columns = [
    {
      name: "ID",
      selector: (row, index) => index + 1,
    },

    {
      name: "Promo Code",
      selector: (row) => row?.promoCode,
      sortable: true,
    },

    {
      name: <strong>Start Date & Time</strong>,
      selector: (row) => {
        if (!row?.startDate) return <p>Invalid date</p>;

        return (
          <p>{dayjs(row?.startDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
    },

    {
      name: <strong>End Date & Time</strong>,
      selector: (row) => {
        if (!row?.endDate) return <p>Invalid date</p>;
        return (
          <p>{dayjs(row?.endDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
    },
    {
      name: <strong>Redemptions</strong>,
      // "3 / 50", or "3 / unlimited" when the server sent a null limit.
      selector: (row) =>
        `${row?.redemptionCount ?? 0} / ${
          row?.maxRedemptions ?? "∞"
        }`,
      sortable: true,
    },
    {
      name: <strong>Free access</strong>,
      selector: (row) =>
        row?.grantDurationDays
          ? `${row.grantDurationDays} day${
              row.grantDurationDays === 1 ? "" : "s"
            }`
          : "-",
      sortable: false,
    },
    {
      name: <strong>Status</strong>,

      // Keyed off an explicit map, not an if/else chain ending in "Expired". The old chain
      // rendered anything it did not recognise as red "Expired", so the three statuses added by
      // WEB-P1-106 would all have displayed as expired. An unknown value now shows itself.
      //
      // Note "Active" is gone: it used to mean USED UP, which is the inversion the ticket is
      // about - a code read Active once it was spent and "Ready to share" while still unused.
      selector: (row) => {
        const palette = {
          "Ready to share": "#f9c114",
          "In use": "#043bc7",
          "Used up": "#6c757d",
          Scheduled: "#0a8754",
          Expired: "red",
        };
        return (
          <span style={{ color: palette[row?.status] ?? "#6c757d" }}>
            {row?.status ?? "-"}
          </span>
        );
      },
    },
  ];

  const filteredData = searchText
    ? dataListItem?.filter((item) => {
        return (
          item?.promoCode?.toLowerCase().includes(searchText?.toLowerCase()) ||
          item?.status?.toLowerCase().includes(searchText?.toLowerCase())
        );
      })
    : dataListItem;
  const clearSearch = () => {
    setSearchText("");
  };
  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />

      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md={6}>
              <h1 className="heading-dash">Generate Promo Code</h1>
            </Col>
          </Row>
          <Card className="ps-3 pe-3 pb-3 mt-3">
            <Form noValidate className="registration_tournament">
              <Row>
                <Form.Group as={Col} md="6 mt-3" controlId="validationCustom02">
                  <Form.Label>Redeemable until</Form.Label>
                  <DatePicker
                    placeholder="End Date"
                    format="MM/dd/yyyy hh:mm:ss aa"
                    value={endDate}
                    disabledDate={(date) =>
                      date < new Date(new Date().setHours(0, 0, 0, 0))
                    }
                    name="endDate"
                    onChange={handleEndDateChange}
                    required
                  />
                  <Form.Text muted>
                    After this, the code stops working. It does not cut short
                    access already granted.
                  </Form.Text>

                  <Form.Control.Feedback
                    type="invalid"
                    style={{ display: dateValid ? "none" : "block" }}
                  >
                    {DATE_TIME_REQUIRED}
                  </Form.Control.Feedback>
                </Form.Group>
              </Row>
              <Row>
                <Form.Group as={Col} md="6 mt-3" controlId="maxRedemptions">
                  <Form.Label>Max redemptions</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    value={isUnlimited ? "" : maxRedemptions}
                    disabled={isUnlimited}
                    placeholder={isUnlimited ? "Unlimited" : "1"}
                    onChange={(e) => setMaxRedemptions(e.target.value)}
                  />
                  <Form.Check
                    type="checkbox"
                    className="mt-2"
                    id="unlimitedRedemptions"
                    label="Unlimited"
                    checked={isUnlimited}
                    onChange={(e) => setIsUnlimited(e.target.checked)}
                  />
                  <Form.Text muted>
                    How many different accounts may redeem this code. Each
                    account may use it once.
                  </Form.Text>
                </Form.Group>

                <Form.Group as={Col} md="6 mt-3" controlId="grantDurationDays">
                  <Form.Label>Free access (days)</Form.Label>
                  <Form.Control
                    type="number"
                    min="1"
                    value={grantDurationDays}
                    placeholder="30"
                    onChange={(e) => setGrantDurationDays(e.target.value)}
                  />
                  <Form.Text muted>
                    Counted from the moment each player redeems, so everyone
                    gets the same however late they are.
                  </Form.Text>
                </Form.Group>
              </Row>
              <Row md="6 mt-3">
                <Button
                  type="submit"
                  className="update-btn-prof"
                  onClick={handleCode}
                >
                  Generate
                </Button>
              </Row>
            </Form>
          </Card>
          <h1 className="heading-dash mt-4 pb-3">Promo Codes List</h1>
          <div className="group_data_table">
            <div className="table-transaction">
              <h1 className="subscription_heading ms-4 quries">Queries List</h1>
              <div className="search-input filter d-flex align-items-center">
                <input
                  type="text"
                  className="form-control mb-3 mt-3"
                  placeholder="Search..."
                  value={searchText}
                  onChange={handleSearch}
                />
                {searchText && (
                  <button className="btn btn-clear" onClick={clearSearch}>
                    <span>&times;</span> {/* This represents the close icon */}
                  </button>
                )}
              </div>
              {/* <DataTable

                                columns={columns}
                                data={filteredData}
                                pagination
                                paginationPerPage={5}
                                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                paginationTotalRows={filteredData?.length}
                            /> */}
              <div>
                <DataTable
                  columns={columns}
                  data={filteredData}
                  paginationPerPage={perPage}
                  paginationTotalRows={totalRows * 10}
                  paginationDefaultPage={currentPage}
                  onChangePage={setCurrentPage}
                />
                {totalRows > 1 && (
                  <Row>
                    <Col md={12} className="text-right">
                      <div className="pagination-controls">
                        <>
                          <label>Rows per page: </label>{" "}
                          <select
                            id="itemsPerPage"
                            value={perPage}
                            onChange={handlePerPageChange}
                          >
                            {pageOptions.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                        </>

                        <Button
                          onClick={handlePreviousPage}
                          disabled={currentPage === 1}
                        >
                          <icons.ArrowLeft></icons.ArrowLeft>
                        </Button>
                        <span>
                          {" "}
                          {currentPage} of {totalRows}{" "}
                        </span>
                        <Button
                          onClick={handleNextPage}
                          disabled={currentPage >= Math.ceil(totalRows)}
                        >
                          <icons.ArrowRight></icons.ArrowRight>
                        </Button>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
